import { BaseEntity } from "yt-ng-framework";

export class KomitentEmailView extends BaseEntity{
    constructor(){
        super();
    }

    Email:string = null;
    Svojina:string = null;
    Glavni:boolean=null;
    Opis:string=null;
    ZaSef: boolean = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Email=input.Email;
        this.Glavni=input.Glavni;
        this.Svojina=input.Svojina;
        this.Opis=input.Opis;
        this.ZaSef=input.ZaSef;
        return this;
    }

    Serialize(input:KomitentEmailView){
        return input;
    }
}